import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=71c1f4b4"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports